<template>
    <relatorio-page :recibo="true" :exportarExcel="false" :paisagem="false" >
        <v-row v-for="(item, index) in recebiveis" :key="index" class="correcaoQuebra">
            <v-col cols="12" class="pa-0">
                <v-card flat v-if="filtro.layoutId == '0'">

                    <v-card-title>

                        <v-row>
                            <v-col cols="8">
                                <v-img :src="logo" contain eager max-width="400px"/>
                                <!-- <img src="@/assets/images/ekloos.png" class="logo"> -->
                            </v-col>
                            <v-col cols="4">
                                <span>Número: {{item.id}}</span>
                            </v-col>
                        </v-row>

                        <span style="width: 100% ; margin: 40px 0px " class="text-center">Recibo</span>
                        
                    </v-card-title>

                    <v-card-text>
                        <v-row>
                            <v-col cols="12">
                                <span style="font-size: 120% ; color: black">
                                    Recebemos do(a) {{item.doador.nome}} , CPF: {{item.doador.cpfCnpj}} , o valor de {{item.valorFinal.toMoeda(true)}} como donativo para os fins sociais da entidade.
                                </span>
                            </v-col>
                        </v-row>
                        <v-row v-if="filtro.exibirNomeProjeto == 'true' ">
                            <v-col cols="12">
                                <span style="font-size: 120% ; color: black">
                                    Projeto: {{item.projeto.nome}}
                                </span>
                            </v-col>
                        </v-row>
                        <hr class="solid" style="margin: 30px 0px">
                        <v-row>
                            <v-col cols="5"/>
                            <v-col cols="7" class="text-center">
                                <v-row style="margin-bottom: 80px">
                                    <v-col cols="12">
                                        <center>
                                            <span style="font-size: 16px ; color: black" class="text-center">
                                                {{empresa.cidade}}, {{new Date(item.dataPagamento).toLocaleDateString('pt-br',{weekday:'long',day:'numeric',month:'long',year:'numeric'})}}
                                            </span>
                                        </center>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12">
                                        <center>
                                            <v-img :src="assinatura" height="100" max-width="260" contain eager/>
                                        </center>
                                    </v-col>                                    
                                </v-row>
                                <v-row>
                                    <v-col cols="12">
                                        <hr class="solid" style="margin-top: 20px ; margin-bottom:10px">
                                        <span style="font-size: 20px ; color: black" class="text-center">{{empresa.responsavel}}</span>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <hr class="solid" style="margin-top: 20px ; margin-bottom:10px">
                        <v-row>
                            <v-col cols="12">
                                <span style="font-size: 20px ; color: black" class="text-center">{{empresa.logradouro}}</span> <br/>
                                <span style="font-size: 20px ; color: black" class="text-center">{{empresa.bairro}} - {{empresa.cidade}} - {{empresa.estado}}</span> <br/>
                                <span style="font-size: 20px ; color: black" class="text-center">{{empresa.telefone1}} - {{empresa.telefone2}}</span> <br/>
                            </v-col>                            
                        </v-row>
                    </v-card-text>                      

                </v-card>

                <v-card flat height="355px" v-else>
                    
                    <v-card-title>

                        <v-row>
                            <v-col cols="5">
                                <v-img :src="logo" contain eager class="logo"/>
                            </v-col>
                            <v-spacer/>
                            <v-col cols="4" class="text-right">
                                <span style="font-size: 16px">Recibo Nº: {{item.id}}</span> <br/>
                                <span style="font-size: 16px" >Contribuinte N°: {{item.doadorId}}</span>
                            </v-col>
                        </v-row>

                        <span style="width: 100% ; margin: -15px 0px " class="text-center">Recibo</span>
                        
                    </v-card-title>

                    <v-card-text>
                        <v-row>
                            <v-col cols="12">
                                <span style="font-size: 14px ; color: black">
                                    Recebemos o importância de {{item.valorFinal.toMoeda(true)}} do(a) Sr(a) {{item.doador.nome}}, residente na {{item.doador.logradouro}} - {{item.doador.bairro}} - {{item.doador.cidade}} - {{item.doador.estado}}, telefone {{item.doador.telefone}}.
                                </span>
                            </v-col>
                        </v-row>

                        <hr class="solid" style="margin: 5px 0px">

                        <v-row>
                            <v-col cols="12" class="text-right" style="margin: 5px 0px">
                                <span style="font-size: 12px ; color: black ; text-transform: uppercase">{{empresa.cidade}}, {{new Date().toLocaleDateString('pt-br',{day:'numeric',month:'long',year:'numeric'})}}</span> <br/>
                            </v-col>
                            <v-col cols="6"/>
                            <v-col cols="6" class="text-right" style="margin: 40px 0px">

                                <hr class="solid">
                                <span style="font-size: 12px ; color: black">{{empresa.nome}}</span> <br/>
                                <span style="font-size: 12px ; color: black">{{empresa.logradouro}}</span>
                                <span style="font-size: 12px ; color: black"> {{empresa.bairro}} - {{empresa.cidade}} - {{empresa.estado}}</span> <br/>
                                <span style="font-size: 12px ; color: black">{{empresa.telefone1}} - {{empresa.telefone2}}</span> <br/>
                            </v-col>                            
                        </v-row>
                    </v-card-text>

                </v-card>
                
            </v-col>
        </v-row>
    </relatorio-page>
</template>

<script>
import Empresa from '../../../core/domain/geral/Empresa'
import RecebivelService from '../../../core/services/financeiro/RecebivelService'
import { EmpresaService } from '../../../core/services/geral'

export default {
    
    data: () => ({
        filtro:{
            required: true
        },
        overlay: false,
        cabecalhoCompleto: true,
        recebivelService: new RecebivelService(),
        empresaService: new EmpresaService(),
        empresa: new Empresa(),
        sessionApp: {},
        filter: {},
        recebiveis: [] = [],
        assinatura: "",
        logo: ""
    }),
    props:{

    },
    mounted(){
        this.filtro = this.$route.query;

        this.filter = {
            doadorId: this.filtro.doadorId == "0" ? null : Number(this.filtro.doadorId),
            documentoId: this.filtro.documentoId == "0" ? null : Number(this.filtro.documentoId),
            regiaoId: this.filtro.regiaoId == "0" ? null : Number(this.filtro.regiaoId),
            pagamentoInicial: this.filtro.pagamentoInicial ? this.filtro.pagamentoInicial : null,
            pagamentoFinal: this.filtro.pagamentoFinal ? this.filtro.pagamentoFinal : null,
            situacao: 'P',
            recibo: 'S'
        }

        this.sessionApp = JSON.parse(localStorage.sessionApp)

        this.empresaService.ObterPorId(this.sessionApp.empresaId).then(
            res=>{
                this.empresa = res.data
                this.empresaService.GetLogo(this.sessionApp.empresaId).then(
                    res => this.logo = res.data
                )
                this.empresaService.GetAssinatura(this.sessionApp.empresaId).then(
                    res => this.assinatura = res.data
                )
            },
            err => this.$swal('Aviso', err.response.data, 'error')
        )

        this.recebivelService.ListarComFiltro(0,-1,['id'],[],null,[], this.filter, "Doador, Projeto").then(
            res=>{
                this.recebiveis = res.data.items
            },
            err => this.$swal('Aviso', err.response.data, 'error')
        )
    },
    methods:{

    }   

}
</script>

<style>
    .logo{
        max-height: 80px;
        max-width: 250px;
    }
    @media print{
        .correcaoQuebra{
            break-inside: avoid;
        }
    }
</style>